function isOnModuleInit(instance) {
    return instance && 'function' == typeof instance.onModuleInit;
}
function isOnApplicationBootstrap(instance) {
    return instance && 'function' == typeof instance.onApplicationBootstrap;
}
async function callHook(instance, hookName) {
    if (instance && 'function' == typeof instance[hookName]) {
        const result = instance[hookName]();
        if (result && 'function' == typeof result.then) await result;
    }
}
async function callOnModuleInit(instance) {
    if (isOnModuleInit(instance)) await callHook(instance, 'onModuleInit');
}
async function callOnApplicationBootstrap(instance) {
    if (isOnApplicationBootstrap(instance)) await callHook(instance, 'onApplicationBootstrap');
}
export { callHook, callOnApplicationBootstrap, callOnModuleInit, isOnApplicationBootstrap, isOnModuleInit };
